const removeKey = (arr, key) => arr.map(({[key]: _, ...rest}) => rest);

export default removeKey;